class RagstudioHeroSlider extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('[data-ragstudio-hero-track]');
    this.slides = Array.from(this.querySelectorAll('.ragstudio-hero__slide'));
    this.prevButton = this.querySelector('[data-ragstudio-hero-prev]');
    this.nextButton = this.querySelector('[data-ragstudio-hero-next]');
    this.dots = Array.from(this.querySelectorAll('[data-ragstudio-hero-dot]'));
    this.currentIndex = 0;
    this.autoplayEnabled = this.dataset.autoplay === 'true';
    this.autoplayInterval = Number.parseInt(this.dataset.autoplayInterval, 10) || 5000;
    this.autoplayTimer = undefined;

    if (!this.track || this.slides.length < 2) return;

    this.prevButton?.addEventListener('click', () => this.onManualNavigation(this.currentIndex - 1));
    this.nextButton?.addEventListener('click', () => this.onManualNavigation(this.currentIndex + 1));
    this.dots.forEach((dot) => {
      dot.addEventListener('click', () => this.onManualNavigation(Number(dot.dataset.ragstudioHeroDot)));
    });

    this.track.addEventListener('scroll', () => {
      window.requestAnimationFrame(() => this.updateFromScroll());
    });
    this.addEventListener('mouseenter', () => this.stopAutoplay());
    this.addEventListener('mouseleave', () => this.startAutoplay());
    this.addEventListener('focusin', () => this.stopAutoplay());
    this.addEventListener('focusout', () => this.startAutoplay());

    this.updateControls();
    this.startAutoplay();
  }

  goTo(index) {
    const nextIndex = (index + this.slides.length) % this.slides.length;
    const slide = this.slides[nextIndex];

    if (!slide) return;

    this.currentIndex = nextIndex;
    this.track.scrollTo({
      left: slide.offsetLeft - this.track.offsetLeft,
      behavior: 'smooth',
    });
    this.updateControls();
  }

  onManualNavigation(index) {
    this.goTo(index);
    this.restartAutoplay();
  }

  startAutoplay() {
    if (!this.autoplayEnabled || this.autoplayTimer || this.slides.length < 2) return;

    this.autoplayTimer = window.setInterval(() => {
      this.goTo(this.currentIndex + 1);
    }, this.autoplayInterval);
  }

  stopAutoplay() {
    if (!this.autoplayTimer) return;

    window.clearInterval(this.autoplayTimer);
    this.autoplayTimer = undefined;
  }

  restartAutoplay() {
    this.stopAutoplay();
    this.startAutoplay();
  }

  updateFromScroll() {
    const width = this.track.clientWidth || 1;
    const nextIndex = Math.round(this.track.scrollLeft / width);

    if (nextIndex !== this.currentIndex && this.slides[nextIndex]) {
      this.currentIndex = nextIndex;
      this.updateControls();
    }
  }

  updateControls() {
    this.dots.forEach((dot, index) => {
      const active = index === this.currentIndex;
      dot.classList.toggle('is-active', active);
      if (active) {
        dot.setAttribute('aria-current', 'true');
      } else {
        dot.removeAttribute('aria-current');
      }
    });
  }

  disconnectedCallback() {
    this.stopAutoplay();
  }
}

customElements.define('ragstudio-hero-slider', RagstudioHeroSlider);
